import { createAction } from '@reduxjs/toolkit';

export const TESTIMONIALS_SAGA = 'TESTIMONIALS_SAGA';
export const testimonialsSaga = createAction(TESTIMONIALS_SAGA);
